import React, { useState, useEffect } from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import LottieAnimation from '../LottieAnimation';

import './LoadingMap.scss';

export default function LoadingMap(props) {
  const animationData = require('../../../assets/animations/route_loader.json');
  const { t, i18n } = useTranslation();

  const [sentences, setSentences] = useState([]);
  const [currentSentenceIndex, setCurrentSentenceIndex] = useState(0);

  // (Re)load the localized loading messages whenever the language changes.
  useEffect(() => {
    const messages = t('map.loading.messages', { returnObjects: true });
    setSentences(shuffleArray(Array.isArray(messages) ? messages : []));
    setCurrentSentenceIndex(0);
  }, [t, i18n.language]);

  useEffect(() => {
    if (sentences.length === 0) return undefined;
    const interval = setInterval(() => {
      setCurrentSentenceIndex(prevIndex => {
        if (prevIndex >= sentences.length - 1) {
          setSentences(prev => shuffleArray(prev));
          return 0;
        }
        return prevIndex + 1;
      });
    }, 3000); // Change the sentence every 3 seconds

    return () => {
      clearInterval(interval);
    };
  }, [sentences.length]);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="fixed"
      top={0}
      left={0}
      width="100%"
      height="100dvh"
      zIndex={10}
      background="rgba(0, 0, 0, 0.4)"
      userSelect={'none'}
    >
      <VStack>
        <Box className="lottie-animation-fixed no-select">
          <LottieAnimation animationData={animationData} />
        </Box>

        <Text
          textStyle={'paragraphSubHeading'}
          color={'#fafafa'}
          key={sentences[currentSentenceIndex]}
          className="pop-in-out-animation no-select"
        >
          {sentences[currentSentenceIndex]}
        </Text>
      </VStack>
    </Box>
  );
}

function shuffleArray(array) {
  const newArray = [...array];
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
  }
  return newArray;
}
